<template>
  <div id="app">
    <StyleEditor ref="styleEditor" :code="currentStyle"></StyleEditor>
    <ResumeEditor ref="resumeEditor" :markdown="currentMarkdown" :enableHtml="enableHtml"></ResumeEditor>
  </div>
</template>

<script>
import StyleEditor from "./components/StyleEditor";
import ResumeEditor from "./components/ResumeEditor";
import "./assets/reset.css";

export default {
  name: "app",
  components: {
    StyleEditor,
    ResumeEditor
  },
  data() {
    return {
      // 动画延时
      interval: 3,
      currentStyle: "",
      enableHtml: false,
      fullStyle: [
        `/*
 <!-- * Inspired by http://strml.net/-->
<!--* 源码地址 https://gitee.com/zhousiwei/anires-->
 * 大家好，我是梁俊可。
 * 我来写一份简历！
*/

/* 给所有元素加上过渡效果 */
* {
  transition: all .1s;
}
/* 设置背景颜色 */
html {
  color: rgb(222,222,222); background: rgb(0,43,54);
}

/* 设置边框 */
.styleEditor {
  padding: .5em;
  border: 1px solid;
  margin: .5em;
  overflow: auto;
  width: 45vw; height: 90vh;
  /* background: rgb(20,20,20); */
}
/* 代码高亮 */
.token.selector{ color: rgb(133,153,0); }
.token.property{ color: rgb(187,137,0); }
.token.punctuation{ color: yellow; }
.token.function{ color: rgb(42,161,152); }

/* 加3D效果 */
html{
  perspective: 1000px;
}
.styleEditor {
  position: fixed; left: 0; top: 0;
  -webkit-transition: none;
  transition: none;
  -webkit-transform: rotateY(10deg) translateZ(-100px) ;
          transform: rotateY(10deg) translateZ(-100px) ;
}

/* 准备一个编辑器 */
.resumeEditor{
  position: fixed; right: 0; top: 0;
  padding: .5em;  margin: .5em;
  width: 48vw; height: 90vh;
  border: 1px solid;
  background: white; color: #222;
  overflow: auto;
}
/* 开始写简历 */
`,
        `
/*将Markdown格式翻译成HTML
 *再对HTML加点样式
*/
.resumeEditor{
  padding: 2em;
}
.resumeEditor h2{
  display: inline-block;
  border-bottom: 1px solid;
  margin: 1em 0 .5em;
}
.resumeEditor ul,.resumeEditor ol{
  list-style: none;
}
.resumeEditor ul> li::before{
  content: '•';
  margin-right: .5em;
}
.resumeEditor ol {
  counter-reset: section;
}
.resumeEditor ol li::before {
  counter-increment: section;
  content: counters(section, ".") " ";
  margin-right: .5em;
}
.resumeEditor blockquote {
  margin: 1em;
  padding: .5em;
  background: #ddd;
}
`
      ],
      currentMarkdown: "",
      fullMarkdown: `
梁俊可
----
32岁，U3D软件工程师，Go软件工程师，c#软件开发工程师，三维建模工程师。
十年工作经验。
6年的PS平面、AE特效、漫游动画、产品动画、三维建模、倾斜摄影建模经验。
4年的U3D程序开发经验，1年的Go软件开发经验。
从软件设计到程序开发，全栈开发工程师。
<br/>

- [中英文简历](https://zhousiwei.gitee.io/cv/)

技能
----
* PS平面
* AE特效
* 漫游动画
* 产品动画
* 三维建模
* 倾斜摄影
* U3D程序开发
* VR程序开发
* Go程序开发

技术及语言
----
  <!--- **Java**: SpringBoot、SpringCloud、SpringMVC、MyBatis、Shiro、Freemarker-->
  - **前端**: VueJs、Bootstrap、LayUI、jQuery UI
  - **数据库**: MySQL/MariaDB、SQLServer、Oracle、MongoDB、redis
  - **web 服务器**: Nginx、Tomcat、Apache、Jetty
  - **OS**: Linux、Windows
  - **Others**: Git、Svn、Maven、XMind、Visio、IDEA

工作经历
----
1. [河南拓展者集团](http://ljk3d.com)
2. [河南捷安高科股份有限公司](http://ljk3d.com)
3. [郑州畅想高科股份有限公司](http://ljk3d.com)
4. [郑州先进技术研究院-解放军信大研究院智慧城市部](http://ljk3d.com)

开源项目
----
1. [HXD3模拟驾驶应急演练系统](http://ljk3d.com)
2. [HXD3模拟驾驶应急演练系统VR版](http://ljk3d.com)
3. [智慧城市-漫游展示系统](http://ljk3d.com)
4. [四川龙岗石油净化厂局部三维高精度建模](http://ljk3d.com)
5. [四川磨溪天然气净化厂局部三维高精度建模](http://ljk3d.com)
6. [河南商丘变电站三维可视化安全管控系统](http://ljk3d.com)
7. [三维可视化数字孪生平台 B/S架构PC版本](http://ljk3d.com)
8. [三维可视化数字孪生平台 C/S架构Web版本](http://ljk3d.com)

联系我
----
* 联系QQ：**2583493258** | 微信：**15515516519**
* 主要涉及技术：**虚拟仿真平台开发**、**虚拟现实平台开发**、**三维高精度测绘建模渲染**、**三维渲染引擎开发**、**视频可视化**

`
    };
  },
  created() {
    this.makeResume();
  },

  methods: {
    makeResume: async function() {
      await this.progressivelyShowStyle(0);
      await this.progressivelyShowResume();
      await this.progressivelyShowStyle(1);
      await this.showHtml();
      await this.progressivelyShowStyle(2);
    },
    showHtml() {
      return new Promise((resolve, reject) => {
        this.enableHtml = true;
        resolve();
      });
    },
    progressivelyShowStyle(n) {
      return new Promise((resolve, reject) => {
        let interval = this.interval;
        let showStyle = async function() {
          let style = this.fullStyle[n];
          if (!style) {
            return;
          }
          // 计算前 n 个 style 的字符总数
          let length = this.fullStyle
            .filter((_, index) => index <= n)
            .map(item => item.length)
            .reduce((p, c) => p + c, 0);
          let prefixLength = length - style.length;
          if (this.currentStyle.length < length) {
            let l = this.currentStyle.length - prefixLength;
            let char = style.substring(l, l + 1) || " ";
            this.currentStyle += char;
            if (style.substring(l - 1, l) === "\n" && this.$refs.styleEditor) {
              this.$nextTick(() => {
                this.$refs.styleEditor.goBottom();
              });
            }
            setTimeout(showStyle, interval);
          } else {
            resolve();
          }
        }.bind(this);
        showStyle();
      });
    },
    progressivelyShowResume() {
      return new Promise((resolve, reject) => {
        let length = this.fullMarkdown.length;
        let interval = this.interval;
        let showResume = () => {
          if (this.currentMarkdown.length < length) {
            this.currentMarkdown = this.fullMarkdown.substring(
              0,
              this.currentMarkdown.length + 1
            );
            let lastChar = this.currentMarkdown[
              this.currentMarkdown.length - 1
            ];
            let prevChar = this.currentMarkdown[
              this.currentMarkdown.length - 2
            ];
            if (prevChar === "\n" && this.$refs.resumeEditor) {
              this.$nextTick(() => this.$refs.resumeEditor.goBottom());
            }
            setTimeout(showResume, interval);
          } else {
            resolve();
          }
        };
        showResume();
      });
    }
  }
};
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html {
  min-height: 100vh;
}

* {
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// App.vue?c203f6ea